exports = module.exports = require("../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /Users/apple/Documents/object/chinaicac-portal/node_modules/_css-loader@0.28.11@css-loader?{"sourceMap":false,"importLoaders":1}!/Users/apple/Documents/object/chinaicac-portal/node_modules/_postcss-loader@1.3.3@postcss-loader?{"ident":"postcss"}!/Users/apple/Documents/object/chinaicac-portal/src/styles.css
// module id = ../../../../_css-loader@0.28.11@css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../_postcss-loader@1.3.3@postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/styles.css
// module chunks = styles